if (!customElements.get('fuliage-comparison')) {
  customElements.define('fuliage-comparison', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      this.width = undefined;
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width === this.width) return;
        this.width = width;
        this.scheduleAlignment();
      });
      this.observer.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.scheduleAlignment(); });
    }
    scheduleAlignment() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.alignRows());
    }
    alignRows() {
      const tables = [...this.querySelectorAll('.fuliage-comparison__table')];
      const groups = tables.map(table => [table.querySelector('caption'), ...table.querySelectorAll('tr')]);
      groups.flat().forEach(row => row.style.removeProperty('height'));
      if (!matchMedia('(min-width: 1024px)').matches) return;
      const heights = Array.from({length: Math.max(0, ...groups.map(rows => rows.length))}, (_, index) =>
        Math.max(...groups.map(rows => rows[index]?.getBoundingClientRect().height || 0))
      );
      groups.forEach(rows => rows.forEach((row, index) => { row.style.height = `${heights[index]}px`; }));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
